import { useState } from "react";
import {
  alpha,
  Avatar,
  Box,
  Chip,
  Collapse,
  ListItem,
  ListItemAvatar,
  NoSsr,
  Popover, Typography,
  useTheme
} from "@mui/material";
import { tokens } from "../../theme";
import * as React from "react";
import Drawer from "@mui/material/Drawer";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import AddIcon from "@mui/icons-material/Add";
import { Dashboard, HourglassTop, Logout, Timeline, ShoppingCart, CheckCircle, CreditCard } from "@mui/icons-material";
import { useLocation } from "react-router-dom";
import SettingsIcon from "@mui/icons-material/Settings";
import img from "./forCreators_logo.png";
import img_text from "./forCreators_text.png";
import { Link } from "react-router-dom";
import usePayment from "../../hooks/payment_hook";

const drawerWidth = 300;

// const MyListItem = styled(ListItem)(({ theme = useTheme() }) => ({
//   ".MuiTouchRipple-child": {
//     background: tokens(theme.palette.mode).primary[200],
//   },
// }));

type SidebarItemType = {
  title: string;
  to: string;
  icon: any;
  active: string;
  setActive: any;
  subItems?: { title: string; to: string; icon?: any }[];
};

function SidebarItem(Item: SidebarItemType) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setTimeout(() => {
      setAnchorEl(null);
    }, 1500);
  };

  const open = Boolean(anchorEl);

  const ITEM_STYLE: any = {
    marginX: 2,
    pl: 8,
    borderRadius: 2,
    ":hover": {
      // border: `2px solid ${colors.primary[500]}`,
      // color: `${colors.primary[500]}`,
    },
    ":focus": {
      // background: `${colors.grey[200]}`,
    },
    ":selected": {
      background: `${colors.primary[600]}`,
      color: "white",
      fontWeight: "bold"
    },
    ".MuiTouchRipple-child": {
      background: colors.primary[700]
    }
  };
  return (
    <NoSsr>
      <Box onMouseLeave={handlePopoverClose}>
        <ListItem key={Item.title} disablePadding>
          <ListItemButton
            onMouseEnter={handlePopoverOpen}
            onClick={() => {
              Item.setActive(Item.to);
            }}
            component={Link}
            to={Item.to}
            selected={Item.active === Item.to}
            sx={{ ITEM_STYLE }}
          >
            <ListItemIcon sx={{ color: colors.grey[950], cursor: "pointer" }}>
              {Item.icon}
            </ListItemIcon>
            <ListItemText primary={Item.title} />
          </ListItemButton>
        </ListItem>
        {Item.subItems && (
          <Collapse in={open} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {Item.subItems.map((subItem, index) => (
                <ListItemButton
                  key={index}
                  component={Link}
                  to={subItem.to}
                  onClick={() => {
                    Item.setActive(subItem.to);
                  }}
                  selected={Item.active === subItem.to}
                  onMouseEnter={handlePopoverOpen}
                  sx={ITEM_STYLE}
                >
                  {subItem.icon && (
                    <ListItemIcon sx={{ color: colors.grey[950], cursor: "pointer" }}>
                      {subItem.icon}
                    </ListItemIcon>
                  )}
                  <ListItemText primary={subItem.title} />
                </ListItemButton>
              ))}
            </List>
          </Collapse>
        )}
      </Box>
    </NoSsr>
  );
}

export default function Sidebar({ user }: any) {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const location = useLocation();
  const { hasPaid, isCheckingPayment } = usePayment();

  const [active, setActive] = useState<string>(location.pathname);

  function handleActiveChange(active: string) {
    setActive(active);
    // console.log(active);
  }

  return (
    <NoSsr>
      <Box
        id={"Sidebar"}
        // className={'shadow-sidebar h-full sm:flex hidden'}
        sx={{
          display: { lg: "flex", xs: "none" },
          width: drawerWidth,
          height: "100%",
          boxShadow: `2px 0px 15px 0px ${alpha("#000000", 0.2)}`
        }}
      >
        <CssBaseline />
        <Drawer
          sx={{
            width: drawerWidth,
            flexShrink: 0,
            "& .MuiDrawer-paper": {
              width: drawerWidth,
              boxSizing: "border-box"
            }
          }}
          variant="permanent"
          anchor="left"
        >
          <Toolbar>
            <ListItem key={"Logo Bar"} disablePadding>
              <ListItemButton>
                {/*<ListItemAvatar>*/}
                {/*  <Avatar alt="for:Creators" src={img} className={"rounded-none"} />*/}
                {/*</ListItemAvatar>*/}
                <img src={img_text} className={"max-w-full h-auto object-contain"} />
              </ListItemButton>
            </ListItem>
          </Toolbar>
          <Divider />
          <List>
            {/* <SidebarItem
              title={"Dashboard"}
              to={"/dashboard"}
              icon={<Dashboard />}
              active={active}
              setActive={handleActiveChange}
            /> */}
            <SidebarItem
              title={"Add Test"}
              to={"/add"}
              icon={<AddIcon />}
              active={active}
              setActive={handleActiveChange}
            />
            <SidebarItem
              title={"Current Tests"}
              to={"/tests"}
              icon={<Timeline />}
              active={active}
              setActive={handleActiveChange}
            />
            <SidebarItem
              title={"Finished Tests"}
              to={"/finished"}
              icon={<Timeline />}
              active={active}
              setActive={handleActiveChange}
            />
            <Box sx={{ alignItems: "end" }}>
              {!hasPaid && (
                <SidebarItem
                  title={"Subscribe Now"}
                  icon={<ShoppingCart />}
                  active={active}
                  setActive={handleActiveChange}
                  to="/checkout"
                />
              )}
              <SidebarItem
                title={"Settings"}
                icon={<SettingsIcon />}
                active={active}
                setActive={handleActiveChange}
                to="/settings"
              />
              <SidebarItem
                title={"Log Out"}
                icon={<Logout />}
                active={active}
                setActive={handleActiveChange}
                to="/logout"
              />
            </Box>
          </List>

          <Box sx={{ flex: 1, position: "relative", width: "100%" }}>
            <Box
              key={"hello"}
              sx={{
                position: "absolute",
                bottom: "8px",
                width: "100%",
                display: "flex",
                flexDirection: "column"
              }}
            >
              <Divider />
              <Box sx={{ display: "flex", width: "100%", alignItems: "center", p: 2 }}>
                <Avatar sx={{ mr: 2 }} alt={user.name} src={user.picture} />
                <Box>
                  <Typography variant={"h5"}>{user.name}</Typography>
                  <Typography variant={"h6"}>{user.email}</Typography>
                  {(!isCheckingPayment && !hasPaid) && (
                    <Chip
                      icon={<ShoppingCart />}
                      label={"Not a Subscriber!"}
                      color={"default"}
                      size="small"
                      sx={{ mt: 1 }}
                    />
                  )}
                </Box>
              </Box>
            </Box>
          </Box>
        </Drawer>


      </Box>
    </NoSsr>
  );
}
